<template>
  <a-layout>
    <a-layout-header>
      <div class="header-top header">
        <div class="content">
          <div class="logo" @click="pushHome"></div>
          <a-row type="flex" align="middle" class="content-top">
            <a-col :span="12" style="text-align: left">
              <span class="title">意大利CLEAF/可丽芙中国华东地区代理商</span>
            </a-col>
            <a-col :span="12" class="search-input">
              <span class="title">全国客服热线：</span>
              <span class="phone">400 821 5227</span>
              <a-input-search allowClear placeholder="输入关键词" style="width: 250px" @search="onSearch">
                <a-select slot="addonBefore" placeholder="选择" v-model="searchType" style="width: 70px">
                  <a-icon style="color: #000" slot="suffixIcon" type="caret-down" />
                  <a-select-option value="1"> 新闻 </a-select-option>
                  <a-select-option value="2"> 产品 </a-select-option>
                  <a-select-option value="3"> 花色 </a-select-option>
                </a-select>
              </a-input-search>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="header-bottom header" :class="isFixed ? 'isFixed' : ''">
        <div class="content">
          <a-row type="flex" align="middle" class="content-bottom" justify="space-between">
            <a-col :span="6" style="text-align: left">
              <!-- <span class="name-chs">惟嘉经贸</span> -->
              <!-- <span class="name-eng">VIGOUR TRADING</span> -->
              <img src="~@/assets/images/company_log.png" />
            </a-col>
            <a-col :span="16" style="text-align: right">
              <div class="nav">
                <router-link v-for="(link, index) in routeList" :key="index" :to="link.path" class="title">
                  {{ link.meta.title }}
                </router-link>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-layout-header>
    <!-- 底层滚动 -->
    <div class="header-under" :class="isFixed ? 'isFixed' : ''"></div>
    <!-- <div class="header-under"></div> -->
    <a-layout-content>
      <router-view v-if="isRouterAlive" />
      <div class="split"></div>
    </a-layout-content>
    <site-footer variant="dark">
      <template #right>
          <p>
            上海惟嘉经贸有限公司 版权所有<br />
            地址：上海徐汇·宜山路407号-1尚光徐汇中心金座903室<br />
            电话：86-21-64692449<br />
            客服热线：400-821-5227（工作日9:00-17:30）<br />
            邮编：200030<br />
            邮件地址：info@vigour.net.cn<br />
          </p>
          <select name="link" id="" class="link" onchange="window.open(this.value)">
            <option value="#">友情链接</option>
            <option value="http://www.cleaf.com">cleaf</option>
            <option value="http://www.cleafchina.com">cleaf中国</option>
          </select>
      </template>
      <template #bottom>
        <div class="footer-line">
          <a href="https://beian.miit.gov.cn" target="_blank"><span class="title">沪ICP备14004273号-1</span></a>
        </div>
      </template>
    </site-footer>
  </a-layout>
</template>

<script>
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'BasicLayout',
  components: { SiteFooter },
  data() {
    return {
      isFixed: false,
      searchType: '1',
      isRouterAlive: true,
    }
  },
  computed: {
    routeList() {
      const route = []
      this.$router.options.routes[1].children.forEach((el) => {
        if (!el.hidden) {
          route.push(el)
        }
      })
      return route
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    onSearch(value) {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
      switch (this.searchType) {
        case '1':
          this.$router.replace({ path: '/main/news', query: value && { keyword: value } })
          break
        case '2':
          this.$router.replace({ path: '/main/product', query: value && { keyword: value } })
          break
        case '3':
          this.$router.replace({ path: '/main/series', query: value && { keyword: value } })
          break
        default:
          break
      }
    },
    pushHome() {
      const link = this.$router.resolve({ path: '/' })
      window.open(link.href, '_blank')
    },
    handleScroll() {
      // const scroll = document.documentElement.scrollTop || document.body.scrollTop
      // if (scroll > 0) {
      //   this.isFixed = true
      // } else {
      //   this.isFixed = false
      // }
    },
  },
}
</script>

<style lang="stylus" scoped>
.ant-layout
  position relative
  .ant-layout-header
    position fixed
    top 0
    left 0
    height auto
    width 100%
    padding 0
    line-height 1
    z-index 10
    .header
      width 100%
      .content
        max-width 1340px
        margin 0 auto
    .header-top
      position relative
      background-color #1f1f1f
      .logo
        cursor pointer
        position absolute
        background-image url('~@/assets/images/logo.png')
        background-repeat no-repeat
        height 129px
        width 165px
      .content-top
        padding-left 195px
        line-height 44px
        .search-input
          text-align right
          display flex
          flex-direction row
          justify-content flex-end
          align-items center
        .title
          color #cccccc
          font-size 14px
        .phone
          color #ffffff
          font-size 16px
          margin-right 27px
        >>> .ant-select-selection--single
          height 26px
        >>> .ant-select-selection__rendered
          line-height 24px
        >>> .ant-input-group-addon
          border-top-left-radius 10px !important
          border-bottom-left-radius 10px !important
          font-weight bold !important
          color #000 !important
        >>> .ant-select-selection-selected-value
          font-weight bold
        >>> .ant-select
          height 26px
        >>> .ant-input
          height 26px
          border-top-right-radius 10px
          border-bottom-right-radius 10px
    .header-bottom
      background-color #292929
      .content-bottom
        padding-left 195px
        img
          display block
          height 44px
          width auto
        // height 66px
        // transition height 0.3s ease
        &.isFixed
          height 46px
        .name-chs, .name-eng
          display block
          line-height 1
          color #ffffff
          font-weight bold
          width 114px
          text-align justify
          text-justify distribute-all-lines /* ie6-8 */
          text-align-last justify /* ie9 */
          -moz-text-align-last justify /* ff */
          -webkit-text-align-last justify /* chrome 20+ */
          &:after
            content ''
            display inline
            width 100%
            overflow hidden
            height 0
        .name-chs
          font-size 26px
        .name-eng
          font-size 13px
      .nav
        .title
          display inline-block
          padding 0px 14px
          height 66px
          line-height 66px
          background-color #1f1f1f
          color #ffffff
          font-size 16px
          letter-spacing 2px
          &.router-link-active
            background-color #666
  .header-under
    height 110px
    width 100%
    background-color #fff
    transition height 0.3s ease
    &.isFixed
      height 90px
  .ant-layout-content
    background-color #fff
    .split
      height 8px
      width 100%
      background-image url('~@/assets/images/split_bottom.jpg')
      background-repeat repeat-x
  .ant-layout-footer
    background-color #1f1f1f
    padding 0
    .footer
      max-width 1340px
      margin 0 auto
      text-align left
      color #999
      .left
        .qrcode
          display inline-block
          text-align center
          margin-right 24px
          &:last-child
            margin-right 0
          .title
            margin-top 16px
            display block
            font-size 14px
      .right
        line-height 1.8
        > p
          text-indent 0
          display inline-block
          font-size 16px
          margin 30px 0
        .link
          width 100px
    .footer-line
      height 40px
      width 100%
      background-color #000
      border-top 1px #666 solid
      text-align center
      .title
        color #999
        font-size 14px
        line-height 40px
</style>
